import React, { Component } from 'react';
import './Separator.css';

class Separator extends Component {
  render() {
    const { separatorSize, separatorSolid } = this.props.contentBlock;

    if (!this.props.contentBlock) {
      return null;
    }

    return (
      <div
        className={`separator ${
          separatorSolid ? 'solid' : ''
        } ${separatorSize}`}
      >
        <hr />
      </div>
    );
  }
}

export default Separator;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Separator/Separator.js